var exports = {
  "Fj": "xaee3c4fa--8c22ed--read-topic",
  "Cr": "xaee3c4fa--8c22ed--read-topic-dekstop",
  "qG": "xaee3c4fa--8c22ed--read-topic__header",
  "gs": "xaee3c4fa--8c22ed--read-topic__header_text",
  "oS": "xaee3c4fa--8c22ed--read-topic__content",
  "Qj": "xaee3c4fa--8c22ed--read-topic-mobile",
  "hI": "xaee3c4fa--8c22ed--list-content",
};

module.exports = exports;
